import { Directive, TemplateRef, ViewContainerRef, effect, inject, input } from '@angular/core';
import { AssistFeaturesService, type AssistFeatureName } from '../services/assist-features.service';

@Directive({
  selector: '[assistFeatureEnabled]',
  standalone: true,
})
export class AssistFeatureEnabledDirective {
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly featuresService = inject(AssistFeaturesService);

  readonly featureName = input.required<AssistFeatureName>({ alias: 'assistFeatureEnabled' });

  private readonly enabled = this.featuresService.hasFeature(this.featureName);
  private hasView = false;

  constructor() {
    effect(() => {
      this.updateView(this.enabled());
    });
  }

  private updateView(enabled: boolean): void {
    if (enabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!enabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
